const initialState = {
    cityMetaData: {}
};
export default initialState;